<div class="rn-page">
  <div class="help-text-container">
    @if (!currentClient.feed_enabled) {
    <p>
      Every customer that starts a Two Way Conversation will be greeted with an
      Auto Response. It is a generic message welcoming your customer to the
      conversation, and prompting them to ask a question.
    </p>
    }
    @if (currentClient.feed_enabled) {
    <p>
      Every customer that starts a conversation will be greeted with an auto
      response. It is a generic message welcoming your customer to the
      conversation, and prompting them to ask a question.
    </p>
    }
  </div>
  <rn-setup-banner-autoresponse [clientId]="clientId"></rn-setup-banner-autoresponse>
  <div class="rn-page__section">
    @if (
    isLoading() || (isRMAutoResponseEnabled && isErrorAutoResponse)) {
    <div class="rn-page--busy">
      @if (isRMAutoResponseEnabled && isErrorAutoResponse) {
      <div>
        <p class="auto-responses-error-msg">
          Oops, there was an error loading this page. Please try refreshing
        </p>
      </div>
      }
      @if (
      !isRMAutoResponseEnabled ||
      (isRMAutoResponseEnabled && !isErrorAutoResponse)
      ) {
      <app-spinner [styleRules]="{ transform: 'translateY(250px)' }"></app-spinner>
      }
    </div>
    } @else {
    @if (autoResponseForm && (!isRMAutoResponseEnabled || !isFeedEnabled)) {
    <form class="form-group" [formGroup]="autoResponseForm">
      <h3>Auto Responses</h3>
      <div>
        <div style="display: flex" class="input-container input-group-with-preview clearfix">
          <rn-generic-phone>
            @if (!defaultProductGroup) {
            <app-spinner [styleRules]="{ transform: 'translateY(100px)' }"></app-spinner>
            }
            @if (defaultProductGroup) {
            <wire-header [productGroup]="defaultProductGroup"></wire-header>
            }
            @if (defaultProductGroup) {
            <two-way-preview [productGroup]="defaultProductGroup"
              [messageText]="defaultAutoResponseCtl.value"></two-way-preview>
            }
          </rn-generic-phone>
          <div class="input-group-with-preview__fields fields-group">
            <label for="default-auto-response">Auto Response Message</label>
            <p>
              All of your customers will receive this auto response when they
              start a conversation during working hours.
            </p>
            <div [ngClass]="{
                  'has-error':
                    defaultAutoResponseCtl.invalid &&
                    defaultAutoResponseCtl.touched
                }">
              <textarea class="form-control" name="default-auto-response" maxlength="8000"
                formControlName="default_auto_response"></textarea>
              <app-error-display [control]="defaultAutoResponseCtl"></app-error-display>
            </div>
          </div>
        </div>
        <h3>After Hours Auto Response</h3>
        <div style="display: flex" class="input-container input-group-with-preview clearfix">
          <rn-generic-phone>
            @if (!defaultProductGroup) {
            <app-spinner [styleRules]="{ transform: 'translateY(100px)' }"></app-spinner>
            }
            @if (defaultProductGroup) {
            <wire-header [productGroup]="defaultProductGroup"></wire-header>
            }
            @if (defaultProductGroup) {
            <two-way-preview [productGroup]="defaultProductGroup"
              [messageText]="afterHoursAutoResponseCtl.value"></two-way-preview>
            }
          </rn-generic-phone>
          <div class="input-group-with-preview__fields fields-group">
            <label for="after-hours-auto-response">After Hours Auto Response Message</label>
            <p>
              All of your customers will receive this auto response when they
              start a conversation during the After Hours window. Don't forget
              to review and adjust your After Hours window below.
            </p>
            <div [ngClass]="{
                  'has-error':
                    afterHoursAutoResponseCtl.invalid &&
                    afterHoursAutoResponseCtl.touched
                }">
              <textarea class="form-control" name="after-hours-auto-response" maxlength="8000"
                formControlName="after_hours_auto_response"></textarea>
              <app-error-display [control]="afterHoursAutoResponseCtl"></app-error-display>
            </div>
            @if (twoWayConfig.after_hours_blackout_window) {
            <app-blackout-select [(blackoutWindow)]="twoWayConfig.after_hours_blackout_window"
              [labelPrefix]="'After Hours'" [thingBeingSent]="'the After Hours Response'"
              [invert]="true"></app-blackout-select>
            }
          </div>
        </div>
      </div>
    </form>
    }
    <!-- New auto responses form -->
    @if (
    isRMAutoResponseEnabled &&
    isFeedEnabled &&
    !isErrorAutoResponse &&
    autoResponseForm
    ) {
    <form class="form-group" [formGroup]="autoResponseForm">
      <h3>Auto Responses</h3>
      <div>
        <div class="auto-responses-container">
          <div class="phone-container">
            <rn-generic-phone>
              <two-way-preview-react [autoResponseMessage]="autoResponseMessageFeed" [brandingColor]="headerColor"
                [isTranslationsEnabled]="isTranslationsEnabled"
                [id]="'auto-response-preview-' + selectedAutoResponse"></two-way-preview-react></rn-generic-phone>
          </div>
          <div class="auto-responses-input-group">
            @if (isTranslationsEnabled) {
            <div class="select-container">
              <label for="language-select">Select the language you wish to configure</label>
              <div class="language-select-row">
                <mat-form-field appearance="outline" class="language-select-field">
                  <mat-select #languageSelect panelClass="language-select-panel" id="language-select"
                    [value]="languageCode" [disabled]="isErrorSupportedLanguages || !supportedLanguages.length"
                    (selectionChange)="onLanguageChange($event.value)">
                    @for (language of supportedLanguages; track language.code) {
                    <mat-option [value]="language.code" [attr.data-testid]="'language-select-option-' + language.code">
                      {{ language.name }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (isErrorSupportedLanguages) {
                <p class="supported-languages-error">
                  Ops, could not load supported languages.
                </p>
                }
              </div>
            </div>
            }
            <div class="auto-responses-wrapper" (click)="setSelectedAutoResponse('default-auto-response')">
              <div class="vertical" [ngClass]="{
                    active: selectedAutoResponse === 'default-auto-response'
                  }"></div>
              <div class="auto-responses-input auto-responses-fields-group" [ngClass]="{
                    active: selectedAutoResponse === 'default-auto-response'
                  }">
                <label for="default-auto-response">
                  Welcome auto response
                  @if (currentLanguageLabel) {
                  <span class="auto-response-language">({{ currentLanguageLabel }})</span>
                  }
                </label>
                <p>
                  Customers will receive this auto response when they start a
                  conversation during the defined hours of operation.
                </p>
                <div [ngClass]="{
                      'has-error':
                        defaultAutoResponseCtl.invalid &&
                        defaultAutoResponseCtl.touched
                    }">
                  <textarea class="form-control" name="default-auto-response" maxlength="8000"
                    formControlName="default_auto_response" [placeholder]="getAutoResponsePlaceholder('businessHours')"
                    dir="auto"></textarea>
                  <app-error-display [control]="defaultAutoResponseCtl"></app-error-display>
                </div>
              </div>
            </div>
            <div class="auto-responses-wrapper" (click)="setSelectedAutoResponse('after-hours-auto-response')">
              <div class="vertical" [ngClass]="{
                    active: selectedAutoResponse === 'after-hours-auto-response'
                  }"></div>
              <div class="auto-responses-input auto-responses-fields-group" [ngClass]="{
                    active: selectedAutoResponse === 'after-hours-auto-response'
                  }">
                <label for="after-hours-auto-response">
                  After Hours auto response
                  @if (currentLanguageLabel) {
                  <span class="auto-response-language">({{ currentLanguageLabel }})</span>
                  }
                </label>
                <p>
                  Customers will receive this auto response when they send a
                  message outside of the defined hours of operation.
                </p>
                <div [ngClass]="{
                      'has-error':
                        afterHoursAutoResponseCtl.invalid &&
                        afterHoursAutoResponseCtl.touched
                    }">
                  <textarea class="form-control" name="after-hours-auto-response" maxlength="8000"
                    formControlName="after_hours_auto_response" [placeholder]="getAutoResponsePlaceholder('afterHours')"
                    dir="auto"></textarea>
                  <app-error-display [control]="afterHoursAutoResponseCtl"></app-error-display>
                </div>
              </div>
            </div>
            <div class="auto-responses-wrapper" (click)="setSelectedAutoResponse('out-of-office-auto-response')">
              <div class="vertical" [ngClass]="{
                    active:
                      selectedAutoResponse === 'out-of-office-auto-response'
                  }"></div>
              <div class="auto-responses-input auto-responses-fields-group" [ngClass]="{
                    active:
                      selectedAutoResponse === 'out-of-office-auto-response'
                  }">
                <label for="out-of-office-auto-response">
                  Out of Office auto response
                  @if (currentLanguageLabel) {
                  <span class="auto-response-language">({{ currentLanguageLabel }})</span>
                  }
                </label>
                <p>
                  Customers will receive this auto response when the Out of
                  Office response is enabled.
                  <span class="bold">This will override operating hours and any after hours
                    messaging until disabled.</span>
                </p>
                <div [ngClass]="{
                      'has-error':
                        outOfOfficeAutoResponseCtl.invalid &&
                        outOfOfficeAutoResponseCtl.touched
                    }">
                  <textarea class="form-control" name="out-of-office-auto-response" maxlength="8000"
                    formControlName="out_of_office_auto_response"
                    [placeholder]="getAutoResponsePlaceholder('outOfOffice')" dir="auto"></textarea>
                  <app-error-display [control]="outOfOfficeAutoResponseCtl"></app-error-display>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    }
    }

  </div>

  <div class="button-container">
    @if (isTranslationsEnabled) {
    <button class="btn btn-primary" id="save-btn" (click)="saveWithoutNavigation()" [disabled]="
                        (!isLoading() && !this.autoResponseForm.valid) ||
                  (isRMAutoResponseEnabled && isErrorAutoResponse) ||
                  isFallbackPendingUpdates
                      ">
      <span i18n="Label for Save button on multilingual configuration" id="save-button">
        Save
      </span>
    </button>
    } @else {
    <button class="btn btn-primary" id="next-btn" (click)="saveAndContinue()" [disabled]="
                        (!isLoading() && !this.autoResponseForm.valid) ||
                        (isRMAutoResponseEnabled && isErrorAutoResponse)
                      ">
      <span i18n="Label for Next button on new client configuration" id="save-and-next-button">
        Save and Next
      </span>
      <span class="icon icon-right">
        <i class="fa fa-arrow-right"></i>
      </span>
    </button>
    }
  </div>
</div>

<message-dialog #autoResponseErrorMessage [showCancel]="false"></message-dialog>
<unsaved-changes-dialog #unsavedChangesDialog [confirmDisabled]="!!autoResponseForm && !autoResponseForm.valid"
  (confirm)="onUnsavedChangesSave()" (cancel)="onUnsavedChangesDiscard()"
  (dismiss)="onUnsavedChangesDismiss()"></unsaved-changes-dialog>